import React from 'react'
import styled from 'styled-components'

const Input = styled.input`
  border: 1px solid ${({ theme }) => theme.mocaGrey};
  border-radius: 6px;
  font-size: 14px;
  height: 34px;
  padding: 6px 12px;
  min-width: 100%;
`

export const inputFormatter = (cell, row, rowIndex, formatExtraData) => {
  const {
    type = 'text',
    field,
    fn,
  } = formatExtraData

  return (
    <Input
      type={type}
      value={row[field] || ''}
      onChange={e => fn(e.target.value, row, field, rowIndex)}
    />
  )
}
